module.exports = (__webpack_require__(14))(85);


//////////////////
// WEBPACK FOOTER
// delegated ../../third-party-assemblies/Infragistics/IgniteUI/16.2.20162.2040/js/modules/infragistics.templating.js from dll-reference obpa_dependencies
// module id = 417
// module chunks = 0